

/**
 * @param {Function} fn 防抖函数
 * @param {Number} delay 延迟时间
 */
export function debounce(fn, delay) {
  var timer;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

/**
 * @param {date} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
export function formatTime(time, fmt) {
  if (!time) return '';
  else {
    const date = new Date(time);
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      );
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        );
      }
    }
    return fmt;
  }
}


/**
 * 全屏
 */
export function fullScreen() {
  var de = document.documentElement;
  if (de.requestFullscreen) {
    de.requestFullscreen();
  } else if (de.mozRequestFullScreen) {
    //兼容火狐
    de.mozRequestFullScreen();
  } else if (de.webkitRequestFullScreen) {
    //兼容谷歌等可以webkitRequestFullScreen也可以webkitRequestFullscreen
    de.webkitRequestFullScreen();
  } else if (de.msRequestFullscreen) {
    //兼容IE,只能写msRequestFullscreen
    de.msRequestFullscreen();
  }
}
/**
 * 退出全屏
 */
export function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}
// 转化ABC
export function letterFize(value) {
  if (value == 0) {
    return 'A'
  } else if (value == 1) {
    return 'B'
  } else if (value == 2) {
    return 'C'
  } else if (value == 3) {
    return 'D'
  } else if (value == 4) {
    return 'E'
  } else if (value == 5) {
    return 'F'
  } else if (value == 6) {
    return 'G'
  }
}
// 转化123
export function letterNum(value) {
  if (value == 'A') {
    return 0
  } else if (value == 'B') {
    return 1
  } else if (value == 'C') {
    return 2
  } else if (value == 'D') {
    return 3
  } else if (value == 'E') {
    return 4
  } else if (value == 'F') {
    return 5
  } else if (value == 'G') {
    return 6
  }
}
/**
 * 阿拉伯数字转中文数字
 * @param {阿拉伯数字} num 
 * @returns 中文数字
 */
export function numTochinese(num) {
  var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
  if (!num || isNaN(num)) return '零'
  var english = num.toString().split('')
  var result = ''
  for (var i = 0; i < english.length; i++) {
    var des_i = english.length - 1 - i// 倒序排列设值
    result = arr2[i] + result
    var arr1_index = english[des_i]
    result = arr1[arr1_index] + result
  }
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十') // 将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零+/g, '零') // 合并中间多个零为一个零
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万') // 将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/亿万/g, '亿') // 将【亿万】换成【亿】
  result = result.replace(/零+$/, '') // 移除末尾的零
  // 将【一十】换成【十】
  result = result.replace(/^一十/g, '十')
  return result
}

export function topicRequirement(value) {
  if (value == '三项') {
    return '三选一'
  }
}